import requestAxios from '@/utils/request'

export function exportBarcodeApi (data) {
  return requestAxios.post('enter-score/export-barcode', data, {responseType: 'blob'})
}

export function exportExcelApi (data) {
  return requestAxios.post('enter-score/export-excel', data, {responseType: 'blob'})
}

export function exportStatisticApi (data) {
  return requestAxios.post('enter-score/statistic/course', data, {responseType: 'blob'})
}

export function exportExaStudentInvalid (data) {
  return requestAxios.post('enter-score/export-exa-student-invalid', data, {responseType: 'blob'})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/export.js